// @ts-nocheck
// import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper"; // Starter Custom Code
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import {
    getCurrentPage,
    getLocation,
    removeAbsoluteUrl,
} from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SignInChangePasswordForm from "@insite/content-library/Widgets/SignIn/SignInChangePasswordForm";
import SignInResetPasswordForm from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { CheckboxProps } from "@insite/mobius/Checkbox";
import { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconProps } from "@insite/mobius/Icon/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography/Typography";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Starter Custom Code
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { useState } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps } from "styled-components";

// Starter Custom
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { formButtonGridItemProps, formGridProps } from "@store/Themes/common/props/form";
import { signInProps } from "@store/Themes/common/props/signIn";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useState } from "react";

/* Store Custom Code - Start */
import FormWrapper from "@store/Library/Components/Toolkit/FormWrapper";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code - End */

const enum fields {
    changePasswordInstructions = "changePasswordInstructions",
    fullWidthButton = "fullWidthButton",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.changePasswordInstructions]: string;
        [fields.fullWidthButton]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{ returnUrl?: string; externalError?: string }>(location.search);
    const isSignInPage = getCurrentPage(state).type === "SignInPage";
    const returnUrl = isSignInPage
        ? removeAbsoluteUrl(parsedQuery.returnUrl)
        : encodeURIComponent(`${location.pathname}${location.search}`);

    return {
        accountSettings: getSettingsCollection(state).accountSettings,
        returnUrl,
        externalError: parsedQuery.externalError,
    };
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

const mapDispatchToProps = {
    signIn,
};

export interface SignInExistingAccountStyles {
    form?: InjectableCss;
    rememberMeCheckbox?: CheckboxProps;
    rememberMeCheckboxGroup?: CheckboxGroupComponentProps;
    userNameTextField?: TextFieldProps;
    signInGridContainer?: GridContainerProps;
    icon?: IconProps;
    passwordTextField?: TextFieldProps;
    signInButton?: ButtonPresentationProps;
    signInButtonGridItem?: GridItemProps;
    forgotPasswordGridItem?: GridItemProps;
    rememberMeGridItem?: GridItemProps;
    passwordGridItem?: GridItemProps;
    userNameGridItem?: GridItemProps;
    signInExistingAccountTitle?: TypographyProps;
    forgotPasswordLink?: LinkPresentationProps;
    resetPasswordModal?: ModalPresentationProps;
    changePasswordModal?: ModalPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    /* Store Custom Code - Start */
    ButtonRowGridItem?: GridItemProps;
    headerWrapper?: InjectableCss;
    /* Store Custom Code - End */
}

export const signInExistingAccountStyles: SignInExistingAccountStyles = {
    /* Store Custom Code - Start */
    ButtonRowGridItem: {
        css: css`
            ${({ theme }) => css`
                ${breakpointValues(
                    [theme.design.typography.spacing.base, null, theme.design.typography.spacing.large],
                    "gap",
                )};
            `}
            ${breakpointValues(["wrap", "wrap", "nowrap", "nowrap", "nowrap"], "flex-wrap")}
        `,
    },
    /* Store Custom Code - End */

    passwordTextField: {},

    icon: {},
    signInExistingAccountTitle: signInProps.formTitle,
    userNameGridItem: {
        width: 12,
    },
    passwordGridItem: {
        width: 12,
    },
    signInButtonGridItem: formButtonGridItemProps,
    rememberMeGridItem: {
        width: [12, 6, 6, 6, 6],
        align: "middle",
        css: css`
            height: ${pxToRem(40)};

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            justify-content: flex-end;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    forgotPasswordGridItem: {
        // Store Custom Code
        width: [12, 12, 6, 6, 6],
        align: "middle",
        css: css`
            height: ${pxToRem(40)};
        `,
    },
    forgotPasswordLink: {
        typographyProps: {
            css: css`
                font-weight: ${({ theme }) => theme.design.typography.weight.bold};
            `,
        },
    },
    // Store Custom Code
    signInButton: {
        sizeVariant: "large",
    },
    resetPasswordModal: {
        sizeVariant: "small",
    },
    changePasswordModal: {
        sizeVariant: "small",
    },
    /* Store Custom Code - Start */
    wrapper: {
        css: css`
            display: grid;
            ${({ theme }) => css`
                ${breakpointValues(
                    [theme.design.typography.spacing.base, null, theme.design.typography.spacing.large],
                    "gap",
                )};
            `}
        `,
    },
    signInGridContainer: {
        ...formGridProps.gridContainer,
        css: css`
            ${({ theme }) => css`
                ${gridGapStyles([
                    theme.design.typography.spacing.base,
                    theme.design.typography.spacing.base,
                    theme.design.typography.spacing.base,
                    theme.design.typography.spacing.large,
                    theme.design.typography.spacing.large,
                ])}
            `}
        `,
    },
    /* Store Custom Code - End */
};

/**
 * @deprecated Use signInExistingAccountStyles instead.
 */
export const signInExistingAccount = signInExistingAccountStyles;
const styles = signInExistingAccountStyles;
const StyledForm = getStyledWrapper("form");

const SignInExistingAccount = ({ signIn, fields, accountSettings, returnUrl, externalError, theme }: Props) => {
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [isSignInClicked, setIsSignInClicked] = useState(false);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState(externalError || "");

    const showRememberMe = accountSettings.rememberMe;

    const signInHandler = (newPassword?: string) => {
        const pass = newPassword || password;
        setIsSignInClicked(true);
        if (!userName || !pass) {
            return;
        }

        if (accountSettings.useEmailAsUserName && !validateEmail(userName)) {
            return;
        }

        const queryParams = parseQueryString<{ returnUrl?: string }>(window.location.search);
        const returnUrl = removeAbsoluteUrl(queryParams.returnUrl?.toString());

        setErrorMessage("");

        signIn({
            userName,
            password: pass,
            rememberMe,
            returnUrl,
            skipRedirect: theme?.signIn?.useOverlay,
            onError: (error, statusCode) => {
                if (statusCode === 422) {
                    setIsChangePasswordModalOpen(true);
                    return;
                }
                setErrorMessage(error);
            },
        });
    };

    const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        signInHandler();
    };

    const onResetPasswordClose = () => {
        setIsResetPasswordModalOpen(false);
    };

    const onChangePasswordClose = () => {
        setIsChangePasswordModalOpen(false);
    };

    const onPasswordChanged = (newPassword: string) => {
        setPassword(newPassword);
        setIsChangePasswordModalOpen(false);
        signInHandler(newPassword);
    };

    const validateUserName = () => {
        if (isSignInClicked) {
            if (userName) {
                if (accountSettings.useEmailAsUserName && !validateEmail(userName)) {
                    return siteMessage("SignInInfo_Email_Validation");
                }
            } else {
                return accountSettings.useEmailAsUserName
                    ? siteMessage("SignInInfo_Email_Required")
                    : siteMessage("SignInInfo_UserName_Required");
            }
        }

        return "";
    };

    const userErrorMessage = validateUserName();
    const passwordErrorMessage =
        !password && isSignInClicked ? siteMessage("SignInInfo_Password_Required") : errorMessage || "";

    const signInButtonCss = css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                fields.fullWidthButton
                    ? css`
                          width: 100%;
                      `
                    : null,
                fields.fullWidthButton
                    ? css`
                          width: 100%;
                      `
                    : null,
                fields.fullWidthButton
                    ? css`
                          width: 100%;
                      `
                    : null,
            ])}
    `;

    return (
        <StyledWrapper {...styles.wrapper /* Starter Custom Code - StyledWrapper */}>
            {/* Store Custom Code */}
            <StyledWrapper {...styles.headerWrapper}>
                <Typography {...styles.signInExistingAccountTitle}>{translate("Sign In")}</Typography>
                <Typography>{siteMessage("Connect_To_Shop_Message")}</Typography>
            </StyledWrapper>
            {/* Starter Custom Code - StoreFormWrapper */}
            <FormWrapper>
                <StyledForm {...styles.form} onSubmit={submitHandler} noValidate>
                    <GridContainer {...styles.signInGridContainer}>
                        <GridItem {...styles.userNameGridItem}>
                            <TextField
                                id="userName"
                                label={accountSettings.useEmailAsUserName ? translate("Email") : translate("User Name")}
                                onChange={e => setUserName(e.currentTarget.value)}
                                value={userName}
                                error={userErrorMessage}
                                autoComplete="username"
                                data-test-selector="signIn_userName"
                                // Starter Custom Code
                                required // A11Y - this field is required
                            />
                        </GridItem>
                        <GridItem {...styles.passwordGridItem}>
                            <TextField
                                id="password"
                                {...styles.passwordTextField}
                                label={translate("Password")}
                                onChange={e => setPassword(e.currentTarget.value)}
                                value={password}
                                error={passwordErrorMessage}
                                // Store Custom Code
                                iconProps={password ? { ...styles.icon, src: showPassword ? EyeOff : Eye } : undefined}
                                iconClickableProps={{
                                    onClick: () => {
                                        setShowPassword(!showPassword);
                                    },
                                    type: "button",
                                }}
                                clickableText={
                                    showPassword
                                        ? translate("Hide password")
                                        : translate("Show password") /* Starter Custom Code - A11Y */
                                }
                                autoComplete="current-password"
                                data-test-selector="signIn_password"
                                type={showPassword ? "text" : "password"}
                                // Starter Custom Code
                                required // A11Y - this field is required
                            />
                        </GridItem>
                        {/* Starter moved Code - rememberMeGridItem */}

                        {/* Starter moved Code */}
                        {/* Bunzl Deleted Code /}
                        {/* Starter moved Code */}
                        {/* Store Custom Code - Start */}
                        <GridItem width={12} align="middle" {...styles.ButtonRowGridItem}>
                            <GridItem {...styles.signInButtonGridItem}>
                                <Button
                                    {...styles.signInButton}
                                    css={signInButtonCss}
                                    sizeVariant="large"
                                    variant="secondary"
                                    type="submit"
                                    data-test-selector="signIn_submit"
                                >
                                    {translate("Sign In")}
                                </Button>
                                <Modal
                                    headline={translate("Change Password")}
                                    {...styles.changePasswordModal}
                                    isOpen={isChangePasswordModalOpen}
                                    handleClose={onChangePasswordClose}
                                >
                                    <SignInChangePasswordForm
                                        enteredUserName={userName}
                                        enteredPassword={password}
                                        instructionsText={fields.changePasswordInstructions}
                                        onPasswordChanged={onPasswordChanged}
                                    />
                                </Modal>
                            </GridItem>
                            <GridItem {...styles.forgotPasswordGridItem}>
                                <Link
                                    {...styles.forgotPasswordLink}
                                    type="button"
                                    onClick={() => setIsResetPasswordModalOpen(true)}
                                    data-test-selector="signIn_forgotPassword"
                                >
                                    {translate("Forgot Password?")}
                                </Link>
                                <Modal
                                    headline={translate("Reset Password")}
                                    {...styles.resetPasswordModal}
                                    isOpen={isResetPasswordModalOpen}
                                    handleClose={() => onResetPasswordClose()}
                                    data-test-selector="resetPasswordModal"
                                >
                                    <SignInResetPasswordForm onClose={() => onResetPasswordClose()} />
                                </Modal>
                            </GridItem>
                        </GridItem>
                        {/* Store Custom Code - End */}
                    </GridContainer>
                </StyledForm>
            </FormWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SignInExistingAccount),
    definition: {
        allowedContexts: ["SignInPage", "SignInOverlay"],
        group: "Sign In",
        icon: "LogIn",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.changePasswordInstructions,
                editorTemplate: "RichTextField",
                displayName: "Change Password Instructions",
                defaultValue: "A password change is required for your account before you may continue.",
                extendedConfig: { height: 170 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                sortOrder: 0,
            },
            {
                name: fields.fullWidthButton,
                displayName: "Full Width Button",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
